import { AppRoutes } from 'src/app/shared/routes/routes';

export interface ReportCard {
  name: string;
  description: string;
  icon: string;
  route: string | null;
  permissions?: string[];
  featureFlag?: string;
}

export const reportCardsOperations: ReportCard[] = [
  {
    name: 'PAs Report',
    description: 'View and manage PAs report for location',
    icon: 'fa-solid fa-check-to-slot',
    route: AppRoutes.reports.pas,
    permissions: ['update_clients','view_all_clients'],
  },
  {
    name: 'Worked Hours By Providers Report',
    description: 'View and manage hours worked by provider by clients',
    icon: 'fa-solid fa-user-tie',
    route: AppRoutes.reports.workedHours,
    permissions: ['view_employees', 'view_all_clients'],
  },
  {
    name: 'Scorecard Report',
    description: 'coming soon',
    icon: 'fa-solid fa-sd-card',
    route: null,
    permissions: ['view_employees'],
  },
  {
    name: 'Growth Report',
    description: 'coming soon',
    icon: 'fa-solid fa-arrow-up-right-dots',
    route: null,
    permissions: ['view_employees'],
  },
  {
    name: 'P&L Report',
    description: 'coming soon',
    icon: 'fa-solid fa-user-tie',
    route: null,
    permissions: ['view_employees'],
  },
  {
    name: 'Business Plan Report',
    description: 'coming soon',
    icon: 'fa-solid fa-briefcase',
    route: null,
    permissions: ['view_employees'],
  },
  {
    name: 'Service Delivery Report',
    description: 'coming soon',
    icon: 'fa-solid fa-truck',
    route: null,
    permissions: ['view_employees'],
  },
  {
    name: 'Waitlist Report',
    description: 'coming soon',
    icon: 'fa-solid fa-hourglass-end',
    route: null,
    permissions: ['view_employees'],
  },
  {
    name: 'Parent/Caregiver Satisfaction Report',
    description: 'coming soon',
    icon: 'fa-solid fa-person-breastfeeding',
    route: null,
    permissions: ['view_employees'],
  },
  {
    name: 'Credentialing and Compliance Report',
    description: 'coming soon',
    icon: 'fa-solid fa-address-card',
    route: null,
    permissions: ['view_employees'],
  },
  {
    name: 'Payroll and Benefits Report',
    description: 'coming soon',
    icon: 'fa-solid fa-credit-card',
    route: null,
    permissions: ['view_employees'],
  },
  {
    name: 'Staff Productivity Report',
    description: 'coming soon',
    icon: 'fa-solid fa-users-between-lines',
    route: null,
    permissions: ['view_employees'],
  },
  {
    name: 'Billing Corrections Report',
    description: 'coming soon',
    icon: 'fa-solid fa-money-bill-transfer',
    route: null,
    permissions: ['view_employees'],
  },
  {
    name: 'Client Acquisition Cost (CAC) Report',
    description: 'coming soon',
    icon: 'fa-solid fa-money-check-dollar',
    route: null,
    permissions: ['view_employees'],
  },
];

export const reportCardsBillingCollections: ReportCard[] = [
  {
    name: 'Batches',
    description: 'View and manage claims to send to Claim.md',
    icon: 'fa-solid fa-receipt',
    route: AppRoutes.claims.claims,
    permissions: ['manage_claims'],
  },
  {
    name: 'Logs Report',
    description: 'View and manage notes logs for clients',
    icon: 'fa-solid fa-file-invoice',
    route: AppRoutes.reports.logs,
    permissions: ['manage_notes'],
  },
];

export const reportCardsHumanResources: ReportCard[] = [
  {
    name: 'Billable Hours Report',
    description:
      'View aggregated unit summaries by location and CPT code with weekly breakdown',
    icon: 'fa-solid fa-map-location-dot',
    route: AppRoutes.reports.locationCpt,
    permissions: ['manage_notes'],
  },
  {
    name: 'Expiring Inservices Report',
    description: 'View and manage expirng inservices date by employee',
    icon: 'fa-solid fa-clock-rotate-left',
    route: AppRoutes.reports.expiringInservices,
    permissions: ['view_employees'],
  },
  {
    name: 'Payroll Report',
    description: 'View and manage Payroll report for location',
    icon: 'fa-solid fa-credit-card',
    route: AppRoutes.reports.payroll,
    permissions: ['manage_employees'],
  },
  {
    name: 'Clients without RBT/BCBA Report',
    description: 'View and manage clients without RBT/BCBA report',
    icon: 'fa-solid fa-user-slash',
    route: AppRoutes.reports.unassignedStaff,
    permissions: ['view_all_clients'],
  },
  {
    name: 'Fixed Payments Report',
    description: 'View and manage fixed payments for location',
    icon: 'fa-solid fa-file-invoice-dollar',
    route: AppRoutes.reports.invoice,
    permissions: ['view_invoices'],
  },
  {
    name: 'Clients Incoming Report',
    description: 'View and edit incoming clients',
    icon: 'fa-solid fa-person-arrow-up-from-line',
    route: AppRoutes.reports.clientIncoming,
    permissions: ['update_clients','view_all_clients'],
  },
  {
    name: 'Transient Permissions Report',
    description: 'Grant, revoke, and audit time-limited permissions for active employees',
    icon: 'fa-solid fa-user-lock',
    route: AppRoutes.reports.transientPermissions,
    permissions: ['manage_transient_permissions'],
  },
  {
    name: 'Birthdays Report',
    description: 'View birthdays for clients and employees',
    icon: 'fa-solid fa-cake-candles',
    route: AppRoutes.reports.birthdays,
    permissions: ['view_all_clients', 'view_employees'],
  },
];

export const reportCardsManagement: ReportCard[] = [
  {
    name: 'BCBAs Report',
    description: 'View and manage BCBAs report by patient',
    icon: 'fa-solid fa-users-gear',
    route: AppRoutes.reports.bcbaReport,
    permissions: ['update_clients','view_all_clients'],
  },
  {
    name: 'Clients by Provider Report',
    description: 'View all clients by provider',
    icon: 'fa-solid fa-users',
    route: AppRoutes.reports.providerClients,
    permissions: ['view_employees'],
  },
  {
    name: 'Worked Hours By Providers Report',
    description: 'View and manage hours worked by provider by clients',
    icon: 'fa-solid fa-user-tie',
    route: AppRoutes.reports.workedHours,
    permissions: ['view_employees', 'view_all_clients'],
  },
  {
    name: 'Clients by Eligibility Report',
    description: 'Edit active clients listed by eligibility',
    icon: 'fa-solid fa-person-circle-check',
    route: AppRoutes.reports.clientEligibility,
    permissions: ['update_clients','view_all_clients'],
  },
  {
    name: 'Clients Incoming Report',
    description: 'View and edit incoming clients',
    icon: 'fa-solid fa-person-arrow-up-from-line',
    route: AppRoutes.reports.clientIncoming,
    permissions: ['update_clients','view_all_clients'],
  },
  {
    name: 'Parents Logs Report',
    description: "Manage parent's monthly communication status",
    icon: 'fa-solid fa-user-group',
    route: AppRoutes.reports.clientParentLogs,
    permissions: ['update_clients','view_all_clients'],
  },
  {
    name: 'Clients Communication Report',
    description: 'View and edit clients communications',
    icon: 'fa-solid fa-envelope',
    route: AppRoutes.reports.clientCommunication,
    permissions: ['update_clients','view_all_clients'],
  },
  {
    name: 'Parents Responsibility Report',
    description: 'Edit parents responsibility plan by client',
    icon: 'fa-solid fa-file-invoice',
    route: AppRoutes.reports.parentResponsibility,
    permissions: ['update_clients','view_all_clients'],
  },
  {
    name: 'Employee Payroll Notes Report',
    description: 'Manage employee payroll notes',
    icon: 'fa-solid fa-id-card',
    route: AppRoutes.reports.employeePayrollNotes,
    permissions: ['update_employees','view_employees'],
  },
  {
    name: 'Employee Database',
    description: 'View and notify inactive employees',
    icon: 'fa-solid fa-database',
    route: AppRoutes.reports.rbtDatabase,
    permissions: ['view_employees'],
  },
];

export const reportCardsClinical: ReportCard[] = [
  {
    name: 'BCBAs Report',
    description: 'View and manage BCBAs report by patient',
    icon: 'fa-solid fa-users-gear',
    route: AppRoutes.reports.bcbaReport,
    permissions: ['update_clients','view_all_clients'],
  },
  {
    name: 'Clients Out of Projection',
    description:
      'Clients with data outside expected progress in the last 2 weeks',
    icon: 'fa-solid fa-file-invoice',
    route: AppRoutes.reports.clientProjection,
    permissions: ['view_projection_report'],
  },
  {
    name: 'PAs Report',
    description: 'View and manage PAs report for location',
    icon: 'fa-solid fa-check-to-slot',
    route: AppRoutes.reports.pas,
    permissions: ['update_clients','view_all_clients'],
  },
  {
    name: 'Clients Objectives Status Report',
    description: 'View of past objectives 60 days',
    icon: 'fa-solid fa-users',
    route: AppRoutes.reports.objectivesStatus,
    permissions: ['view_employees'],
  },
  {
    name: 'Supervision Monitoring',
    description: 'View most recent 97155 note for each client',
    icon: 'fa-solid fa-triangle-exclamation',
    route: AppRoutes.reports.supervisionMonitoring,
    permissions: ['view_employees'],
  },
  {
    name: 'Client Note RBT by Plan Report',
    description: 'View most recent client note for each client by plan',
    icon: 'fa-solid fa-file-pen',
    route: AppRoutes.reports.clientNoteRbtByPlan,
    permissions: ['view_employees'],
  },
];

export const reportCardsAdmin: ReportCard[] = [
  {
    name: 'Users and Patients by Location',
    description: 'View active users and active patients grouped by location',
    icon: 'fa-solid fa-location-dot',
    route: AppRoutes.reports.usersPatientsByLocation,
    permissions: ['view_employees', 'view_all_clients'],
  },
  {
    name: 'Ticket Support Report',
    description:
      'View weekly ticket support metrics including response times, resolution times, and status distribution',
    icon: 'fa-solid fa-ticket-alt',
    route: AppRoutes.reports.ticketSupport,
    permissions: ['manage_tickets', 'create_tickets'],
  },
];
